import { render, staticRenderFns } from "./ModalDriverReport.vue?vue&type=template&id=1b5f2134&scoped=true&"
import script from "./ModalDriverReport.vue?vue&type=script&lang=js&"
export * from "./ModalDriverReport.vue?vue&type=script&lang=js&"
import style0 from "./ModalDriverReport.vue?vue&type=style&index=0&id=1b5f2134&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5f2134",
  null
  
)

export default component.exports